import { useState } from "react";
import axios from "axios";
import { useLoading } from "../../context/LoadingContext";

const usePostData = (url) => {
    const { isLoading, setLoading } = useLoading();
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);

    const post = async (body) => {
        if (!url) return;

        const accessToken = sessionStorage.getItem("accessToken");
        const headers = accessToken ? { Authorization: `${accessToken}` } : {};

        try {
            setLoading(true);
            setError(null);
            const res = await axios.post(url, body, { headers });
            setResponse(res?.data);
            return res;
        } catch (err) {
            setError(err?.response?.data);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return { response, isLoading, error, post };
};

export default usePostData;
